import { relativeDayUpper } from './relativeDayUpper.mcom';
import type { PickupTime } from '~/declaration/bops';

export const bopsPickupMessagging = ({
  checkCutOffTimeFlag,
  checkPickupEligibilityFlag,
  deliveryDay,
  cutOffTime,
  curbsideCutOffTime,
}: {
  checkCutOffTimeFlag: string;
  checkPickupEligibilityFlag: string;
  deliveryDay: string;
  cutOffTime: PickupTime;
  curbsideCutOffTime: PickupTime;
}) => {
  const deliveryDayLower = deliveryDay && deliveryDay.toLowerCase();
  let formattedCurbsideMessage = '';
  let inStorePickupRelativeDayUpper = 'NA';
  let curbsidePickupRelativeDayUpper = 'NA';
  let formattedMessage = '';
  const fireLinkTagMessage = '';
  let formattedStoreMessage;

  // get in store pickupRelativeDay for tagging
  inStorePickupRelativeDayUpper = relativeDayUpper(cutOffTime);
  // get curbside pickupRelativeDay for tagging
  curbsidePickupRelativeDayUpper = relativeDayUpper(curbsideCutOffTime);

  switch (true) {
    case checkCutOffTimeFlag === 'noDates' && checkPickupEligibilityFlag === 'bothEligible':
      formattedMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      return `In Store:${formattedMessage}-Curbside:${formattedMessage}`;
    case checkCutOffTimeFlag === 'pickupCutOffTimeOnly' && checkPickupEligibilityFlag === 'bothEligible':
      formattedMessage = deliveryDayLower.toUpperCase();
      return `In Store:${formattedMessage}-Curbside:${formattedMessage}`;
    case checkCutOffTimeFlag === 'otherDateOnly' && checkPickupEligibilityFlag === 'bothEligible':
      return `In Store:${inStorePickupRelativeDayUpper}-Curbside:${curbsidePickupRelativeDayUpper}`;
    case checkCutOffTimeFlag === 'bothDates' && checkPickupEligibilityFlag === 'bothEligible':
      return `In Store:${inStorePickupRelativeDayUpper}-Curbside:${curbsidePickupRelativeDayUpper}`;
    case checkPickupEligibilityFlag === 'inStoreEligibleOnly' && deliveryDayLower === 'today':
      formattedStoreMessage = deliveryDayLower.toUpperCase();
      return `In Store:${formattedStoreMessage}-Curbside:NA`;
    case checkPickupEligibilityFlag === 'inStoreEligibleOnly' && deliveryDayLower !== 'today':
      formattedStoreMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      return `In Store:${formattedStoreMessage}-Curbside:NA`;
    case checkPickupEligibilityFlag === 'curbsideEligibleOnly' && deliveryDayLower !== 'today':
      formattedCurbsideMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      return `In Store:NA-Curbside:${formattedCurbsideMessage}`;
    case checkPickupEligibilityFlag === 'curbsideEligibleOnly' && deliveryDayLower === 'today':
      formattedCurbsideMessage = deliveryDayLower.toUpperCase();
      return `In Store:NA-Curbside:${formattedCurbsideMessage}`;
    case checkPickupEligibilityFlag === 'notEligible':
      return 'In Store:NA-Curbside:NA';
    default:
      break;
  }
  return fireLinkTagMessage;
};
